export const blogPosts = [
  {
    id: 1,
    type: "photography",
    title: "Capturing a Protective Mother with Her Kittens Depending on Her",
    date: "2025-07-03",
    description:
      "A tender moment of a mother cat protecting and nurturing her kittens, reminding me of the love and care of my own mother.",
    content: `I was just passing by when I noticed these beautiful kittens sitting under a scooter. A moment later, I saw them resting on their mother. My heart urged me to capture this scene with my phone. 

As I bent down to take the picture, the mother cat instantly became alert. It reminded me of my own mother—the way she always tells me to stay alert, the way she teaches me to trust only a few people, and the way she protects me when I am shivering with high fevers. Just like how she gently pats me when I cry over a lost friendship.

Watching them also reminded me of how little children hide behind their mother’s legs when they see strangers. Each mother protects in her own way—whether it’s a new mom, an experienced mom, a cat mom, or even a soon-to-be mom.

This post is dedicated to my mother. Love you, Ma. Salute to you, mothers.`,
    image: "/images/blog/mother-cat-kittens.jpg",
    tags: ["photography", "motherhood", "cats", "love", "family"],
  },
  {
    id: 2,
    type: "sketch",
    title: "When Brain Stops Working but Hands Need Some Work... SKETCHING!!",
    date: "2025-09-13",
    description:
      "A spontaneous sketching session during a long break, rediscovering an old hobby and the comfort of putting pencil to paper.",
    content: `After a 2-hour long break, I needed something more than just scrolling on my phone. So, I picked up sketching again after a long time—an old hobby I can never fully leave behind. 

If you look through my notebooks, you'll notice one thing I've drawn consistently: eyes. Maybe it's my INFJ personality craving perfection, or maybe it's just my fascination with capturing emotions. I'm still learning how to draw perfect eyelashes, but that's the fun part—progress comes with every attempt.

This session reminded me how peaceful it feels to let my hands work when my brain feels stuck. And honestly, I owe thanks to my friend for lending me her one and only pencil for this mini art therapy. 

The result? A page full of random sketches—eyes, faces, shapes, and even a little Spidey—each line a reminder of how creativity sneaks back in when you least expect it. More sketches coming soon...`,
    image: "/images/blog/character-sketches.jpg",
    tags: ["sketch", "art", "eyes", "hobby", "traditional-media", "personal"],
  },
  {
    id: 3,
    type: "nature",
    title: "A Giant Swallowtail Caterpillar",
    date: "2025-09-10",
    description:
      "A small encounter with a giant swallowtail caterpillar on our Pati Lebu (Bengali Lime) plant, reminding me of nature’s quiet miracles.",
    content: `That morning, my mom called me while I was half-asleep: 
"Sneha, look—there’s another caterpillar! Should I capture it in a box?"  
In my sleepy haze, I said yes… but ten seconds later added, "Leave it there, it will grow naturally."  

But the tiny storm, busy munching on our Pati Lebu leaves, was already behind bars.  
When I finally woke up, I saw this curious little fellow. Twenty minutes later—no more leaf bites. An hour later—still nothing. Three hours later, I decided to release it back onto the same lime plant.  

The next day, I found it already dried up, as if preparing for its next stage—a pupa was surely on its way. It has now been five days since, and I am still searching for a cocoon on the plant, praying I will witness a small, beautiful butterfly soon.  

And yes, you might wonder: "Another?" Indeed, another. Two years ago, on the very same plant, we found a caterpillar we named *Snowtailed*. That time, I witnessed the entire metamorphosis in a small jar. I still remember the soft touch when I released the butterfly—the tiny legs resting on my fingers.  

Moments like these remind me how magical nature truly is.`,
    image: "/images/blog/giant-swallowtail.jpg",
    tags: [
      "nature",
      "caterpillar",
      "butterfly",
      "life-cycle",
      "patilebu",
      "memories",
    ],
  },
  {
    id: 4,
    type: "sketch",
    title: "Ankhiyaan Milaaoon Kabhi Ankhiyaan Churaaoon",
    date: "2024-12-18",
    description:
      "A simple recreation inspired by a Pinterest post, with my own little 'Sneha touch.'",
    content: `*"Ankhiyaan milaaoon kabhi ankhiyaan churaaoon    
  "Kya tune kiya jaadu  
  Kabhi ghabraaoon kabhi gale lag jaaoon  
  Mera khud pe nahin qaabu  
  Bina paayal ke hi baje ghunghroo"* 

I won’t say much about this one. It was just one of those days when I was randomly scrolling through Pinterest, and this particular post caught my eye. I decided to recreate it, adding my own little twist—my 'Sneha touch.'  

Sometimes, inspiration doesn’t need a story—it’s just about how a few words or a visual spark something inside you. This one did exactly that.`,
    image: "/images/blog/ankhiyaan.jpg",
    tags: ["art", "inspiration", "lyrics", "personal", "pinterest"],
  },
  {
    id: 5,
    type: "photography",
    title: "A Perfect Favourite Pic Looks Like This",
    date: "2025-05-11",
    description:
      "That day it was raining heavily, I was inside the car and my photography instincts kicked in. Captured this beautiful pic, the way the focus was on the window raindrops, the way the background lights are playing a supporting but important role and the cherry on top are the car lights and road. Sometimes words can't describe the emotion we feel in that very moment. I still can't believe without any professional camera I captured my forever longing photography.",
    content: `That day it was raining heavily, and I was sitting inside the car when my photography instincts kicked in. I couldn’t resist capturing this moment — raindrops painting the window, city lights in the background softly blurred, and the reflections on the wet road bringing everything alive.  

Sometimes, words fail to express the emotion of a fleeting moment, and this photo is one of them.  

It reminded me of the timeless melody:  

*"Ek ladki bhigi bhagi si  
Soti raaton mein jaagi si  
Mili ik ajnabi se  
Koyi aage na peechhe  
Tum hi kaho ye koyi baat hai"*  

by the one and only **Kishore Kumar**.  

Rain, music, and a single click — my perfect forever favourite shot.`,
    image: "/images/blog/rainy-night.jpg",
    tags: [
      "photography",
      "rain",
      "night",
      "city-lights",
      "emotions",
      "favourite",
    ],
  },
  {
    "id": 6,
    "type": "writing",
    "title": "Feminine Characters",
    "date": "2024-10-11",
    "description": "A reflection on the strength and elegance of powerful feminine characters like Baroness from Cruella and Miranda Priestly from The Devil Wears Prada — women who command presence, exude confidence, and embody the calm power of true femininity.",
    "content": `Some characters are just like the cherry blueberry cake; the top is coated with a slightly spicy sugar garnish.  

Yesterday night, while watching *Cruella* for the fifth time, I realized something — the Baroness was undoubtedly the villain, but she held more power than Cruella. Not because of inheritance or wealth, but because of her command. Did you notice how everyone seems to obey her? When she was reading about herself in the newspaper, even her bodyguard was terrified to sneeze in her presence — *that* is power.  

One of the best examples of this feminine dominance is Miranda Priestly from *The Devil Wears Prada*. Good God, the power she holds is beyond words. These two women, though often seen as rude or cold, truly embody the art of **femininity**. Yes, the Baroness was cruel, but can we deny that deep down, every woman admires that aura, that control, that grace she carries?  

What I find common between them is simple — *the world doesn’t define them; they define the world.* They are their own praise, their own care, and their own validation.  

Speaking softly, calmly, and slowly — that’s where their real power lies. Their poise, their composure, their deliberate pauses — it all says, “I’m not in a hurry. The world can wait.”  

They are the main characters. They own every room they walk into because they know one simple truth: *My life is mine, and I’m in the driver’s seat.*  

Remember the scene where the Baroness stands still while everyone else panics as the moths fly out of the vault? That calmness — that stillness — is power. Or Miranda, knowing she’s being replaced but holding her emotions back, staying composed, poised.  

That’s what true feminine strength is — not reacting, but *owning*.  `,
    "tags": [
    "writing",
      "feminine-energy",
      "character-analysis",
      "cruella",
      "miranda-priestly",
      "confidence",
      "women-in-power"
    ]
  }, 
  {
    "id": 7,
    "type": "writing",
    "title": "A Rainy Day Encounter ☔",
    "date": "2025-09-20",
    "description": "A poetic short scene of two souls meeting under the rhythm of rain — where a drenched moment turns into the beginning of something magical.",
    "content": `"Ugh!! This rain again... now I have to go in this."  

It started to rain heavily.  

She stopped by the café shed.  

"Ahhh!! This is unfair... my dress, NO!! Why am I still here, just to suffer?"  

A slight wind passed her, a movement — someone's arrival made a noise.  

She shifted her gaze... and found him.  

How can someone be so perfect?! His wet hair, that white transparent shirt, and the raindrops dripping... his lips.  

"Did I just meet an angel?"  

"Huh? Sorry?"  

"Ahh no no, nothing nothing."  

Those blue eyes... are driving me crazy!  

His blue eyes were now lost in the ocean of brown dunes.  

She is beautiful, indeed an art of God.  

Now,  

The cold heart starts to beat fast, the child finds her right home.  

The clock keeps moving, minutes pass.  

The café door opened.  

She blushed, and he smiled.  

She tucked her hair; he huffed his.  

"Hmm, Hi."  

"H... Hi."  

A love story started.  

~ **Sneha Das**  

---

Will come with a few amazing posts soon!! `,
    "image": "/images/blog/rainy-meet-cafe.jpg",
    "tags": [
      "romance",
      "rain",
      "short-story",
      "poetic",
      "love",
      "aesthetic"
    ]
  }
];
